import React from 'react';
import { string } from 'prop-types';

export default function LineDecoration({ color, width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      //   width="1080"
      zoomAndPan="magnify"
      viewBox="0 0 810 1439.999935"
      //   height="1920"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="2a26799b02">
          <path
            d="M 21 62.539062 L 785 62.539062 L 785 1377.289062 L 21 1377.289062 Z M 21 62.539062 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#2a26799b02)">
        <path
          fill={color}
          d="M 610.425781 1377.160156 L 609.371094 1372.570312 C 686.054688 1354.960938 771.871094 1277.570312 779.082031 1149.265625 C 784.902344 1045.742188 745.332031 974.140625 710.417969 910.96875 C 706.511719 903.898438 702.640625 896.890625 698.878906 889.925781 C 662.742188 930.75 612.726562 969.378906 555.667969 1000.261719 C 492.292969 1034.5625 427.167969 1055.925781 372.289062 1060.414062 C 344.054688 1062.726562 295.558594 1057.773438 251.800781 1036.199219 C 215.175781 1018.148438 170.007812 981.964844 162.832031 912.128906 C 157.683594 862.015625 169.0625 818.101562 197.617188 777.886719 C 222.46875 742.882812 257.253906 715.085938 287.945312 690.5625 C 326.902344 659.429688 360.546875 632.542969 368.785156 598.421875 C 384.960938 531.394531 323.566406 513.023438 245.839844 489.769531 C 150.15625 461.136719 31.074219 425.507812 22.398438 278.582031 C 20.167969 240.863281 25.808594 202.898438 39.152344 165.746094 C 51.855469 130.386719 71.542969 95.695312 97.675781 62.632812 L 101.371094 65.554688 C 48.511719 132.433594 22.828125 206 27.101562 278.304688 C 35.582031 421.941406 152.914062 457.046875 247.191406 485.253906 C 324.136719 508.277344 390.589844 528.160156 373.363281 599.527344 C 364.746094 635.214844 330.519531 662.570312 290.882812 694.242188 C 227.769531 744.675781 156.238281 801.839844 167.519531 911.648438 C 179.898438 1032.132812 310.570312 1060.746094 371.90625 1055.71875 C 481.332031 1046.765625 619.375 973.535156 696.503906 885.503906 C 678.796875 852.3125 663.980469 819.863281 660.203125 785.164062 C 653.914062 727.351562 678.144531 694.203125 700.808594 683.382812 C 712.511719 677.796875 725.851562 677.722656 736.488281 683.191406 C 745.085938 687.609375 756.242188 697.957031 760.546875 722.15625 C 764.933594 746.792969 762.796875 772.519531 754.199219 798.621094 C 746.238281 822.792969 732.738281 847.339844 714.066406 871.578125 C 710.3125 876.449219 706.347656 881.308594 702.191406 886.136719 C 706.203125 893.597656 710.351562 901.105469 714.542969 908.691406 C 749.761719 972.417969 789.683594 1044.652344 783.785156 1149.527344 C 780.371094 1210.261719 758.953125 1264.824219 721.839844 1307.324219 C 691.121094 1342.5 650.511719 1367.957031 610.425781 1377.160156 Z M 719.269531 683.847656 C 713.769531 683.847656 708.125 685.109375 702.835938 687.636719 C 681.566406 697.789062 658.863281 729.292969 664.886719 784.65625 C 668.511719 817.980469 682.707031 849.472656 699.808594 881.679688 C 703.464844 877.386719 706.980469 873.054688 710.335938 868.699219 C 748.335938 819.371094 764.097656 768.980469 755.910156 722.984375 C 752.769531 705.332031 745.308594 693.019531 734.335938 687.382812 C 729.75 685.023438 724.578125 683.847656 719.269531 683.847656 Z M 719.269531 683.847656 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

LineDecoration.propTypes = {
  color: string,
  width: string,
  height: string,
};

LineDecoration.defaultProps = {
  color: '#1a1b1d',
  width: '1080',
  height: '1920',
};
